import { render, staticRenderFns } from "./AscUserCommentList.vue?vue&type=template&id=deecc064&"
import script from "./AscUserCommentList.vue?vue&type=script&lang=js&"
export * from "./AscUserCommentList.vue?vue&type=script&lang=js&"
import style0 from "./AscUserCommentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports